<template>
  <div class="d-flex justify-content-end">
    <div v-if="alertValue" class="alert alert-custom alert-dark fixed-bottom d-flex align-items-center" role="alert">
      <div class="alert-icon me-3">
        <i class="flaticon-questions-circular-button"></i>
      </div>
      <div class="d-flex justify-content-between w-100">
        <div class="alert-text text-start flex-grow-1 mt-4" style="font-weight: bold">
          {{ $t('send_mail') }}
        </div>
        <button class="btn text-primary btn-light font-weight-bold mr-2" @click="cancelMail" style="color:white">{{ $t('button.cancel') }}</button>
        <div class="btn btn-icon btn-sm btn-active-light-primary" @click="closeAlert">
          <span class="svg-icon svg-icon-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                    fill="currentColor"/>
              <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                    fill="currentColor"/>
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, ref, watch } from "vue";

  const emits = defineEmits(['cancel', 'update:showingAlert'])

  const props = defineProps({
    showingAlert: {
      type: Boolean,
      required: true
    }
  })

  const alertValue = ref(props.showingAlert)

  watch(() => props.showingAlert, (newValue) => {
    alertValue.value = newValue
  })

  function cancelMail() {
    emits('cancel')
  }

  function closeAlert() {
    alertValue.value = false
    emits('update:showingAlert', false)
  }
</script>

<style scoped>
.alert.alert-custom.alert-dark {
    background-color: #181C32;
    border-color: #181C32;
}
.alert.alert-custom {
    display: flex;
    align-items: stretch;
    padding: 0.5rem 2rem;
}
.alert.alert-dark {
    background-color: #181C32;
    border-color: #181C32;
    color: #ffffff;
}
.alert-dark {
    color: #0c0f1a;
    background-color: #d1d2d6;
    border-color: #bebfc6;
}
.alert {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.42rem;
}
*, *::before, *::after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.fixed-bottom {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  left: 73%;
  width: 25%;
  z-index: 1050;
}
</style>


